import { Component, Input, OnInit } from '@angular/core';
import { ChatService } from '../../services/chat.service';
import { CommonModule } from '@angular/common';
import { MessageTimestampComponent } from '../common/message-timestamp/message-timestamp.component';
import { MESSAGE_UNREAD_TEXT } from '../../utils/constants';

@Component({
  selector: 'app-dynamic-text',
  templateUrl: './dynamic-text.component.html',
  styleUrls: ['./dynamic-text.component.scss'],
  standalone: true,
  imports: [CommonModule, MessageTimestampComponent],
})
export class DynamicTextComponent implements OnInit {
  @Input() input: any;
  @Input() isRead: boolean = false;

  isHovered = false;
  config: any;
  messageText: string = '';
  messageUnreadText: string = MESSAGE_UNREAD_TEXT;

  ngOnInit() {
    this.config = this.input?.config;
    this.messageText = this.input?.message_text;
  }

  constructor(private chatService: ChatService) {}

  get configs() {
    return this.chatService.configs;
  }

  getMessageStyles() {
    return {
      'background-color': this.configs?.colors?.bot_message_background,
      color: this.configs?.colors?.bot_message_text,
      border: `1px solid ${this.configs?.colors?.bot_message_border}`,
      'font-family': this.configs?.fonts?.default_font,
    };
  }
}
